import StandAloneButtons from './StandAloneButtons';

export default StandAloneButtons;
